var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 2.15c.47 0 .85.38.85.85v1.387L18 6.104l2.73-.91a.85.85 0 1 1 .538 1.612l-2.193.731 2.717 8.15a.85.85 0 0 1-.28.992 5.85 5.85 0 0 1-7.023 0 .85.85 0 0 1-.296-.948l2.731-8.194L12.85 6.18v13.97H15a.85.85 0 1 1 0 1.7H9a.85.85 0 0 1 0-1.7h2.15V6.18L7.075 7.537l2.716 8.15a.85.85 0 0 1-.28.992 5.85 5.85 0 0 1-7.022 0 .85.85 0 0 1-.296-.948l2.731-8.194-2.193-.73a.85.85 0 1 1 .537-1.613L6 6.104l5.15-1.717V3c0-.47.38-.85.85-.85M6 9.688l-1.986 5.957a4.16 4.16 0 0 0 3.972 0zm12 0-1.986 5.957a4.16 4.16 0 0 0 3.972 0z",
  clipRule: "evenodd"
})));
export default SvgScale;